import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CentralClienteEditarComponent } from './central-cliente-editar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: ':id', component: CentralClienteEditarComponent}
  ])],
  exports: [RouterModule]
})
export class CentralClienteEditarRoutingModule { }
